import React, { useContext } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import './styles.less';
import { PropTypes } from 'prop-types';
import { rutValidator } from '../../../../../../utils/validators';
import ParamSelect from '../../../../../params/components/ParamSelect';
import paramEndpoints from '../../../../../params/paramEndpoints';
import { EnrollmentFormContext } from '../../../../../../providers/EnrollmentFormContextProvider';
import InputRut from '../../../../../../components/form/inputs/InputRut';
import InputNumber from '../../../../../../components/form/inputs/InputNumber/index';
import form from '../../../../../../utils/form';
import Paragraph from '../../../../../../components/common/Paragraph';

const FormBankData = ({ onFinish }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const allowLettersAndWS = RegExp(
    '^(s*[a-zA-Z0-9áéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1]*)+(s*[a-zA-Z0-9áéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1]*)*[a-zA-Z0-9áéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1 ]*$'
  );

  const initialValues = {
    dataBankito: {
      bankAccounts: [{}],
    },
  };

  return (
    <Row className="formBankData">
      <Col span={24}>
        <Form form={enrollmentForm} initialValues={initialValues} onFinish={onFinish}>
          <Row>
            <Col className="formBankData__title">Datos Bancarios</Col>
          </Row>
          <Row>
            <Col span={23}>
              <p>
                <span className="required">*</span>Nombre, Razón Social o Representante Legal de la
                cuenta
              </p>
              <Form.Item
                name={['dataBankito', 'accountsName']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                  {
                    pattern: allowLettersAndWS,
                    message: 'ingrese solo letras y números',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg={11} xs={23}>
              <p>
                <span className="required">*</span>RUT
              </p>
              <Form.Item
                name={['dataBankito', 'accountsRut']}
                rules={[
                  {
                    required: true,
                    message: 'Rut es requerido',
                  },
                  {
                    validator: rutValidator,
                    message: 'rut invalido',
                  },
                ]}
              >
                <InputRut />
              </Form.Item>
            </Col>
          </Row>
          <Form.List name={['dataBankito', 'bankAccounts']}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                  <>
                    <Row>
                      <Col span={24}>
                        <Paragraph strong>Cuenta bancaria {index + 1}</Paragraph>
                      </Col>
                      <Col lg={11} xs={23}>
                        <p>
                          <span className="required">*</span>Banco
                        </p>
                        <Form.Item
                          {...restField}
                          name={[name, 'bank']}
                          rules={[
                            {
                              required: true,
                              message: 'Dato requerido',
                            },
                          ]}
                        >
                          <ParamSelect
                            paramType={paramEndpoints.BANKS}
                            showSearch
                            placeholder="Seleccionar"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={11} xs={23}>
                        <p>
                          <span className="required">*</span>Tipo de cuenta
                        </p>
                        <Form.Item
                          {...restField}
                          name={[name, 'type']}
                          fieldKey={[fieldKey, 'type']}
                          rules={[
                            {
                              required: true,
                              message: 'Dato requerido',
                            },
                          ]}
                        >
                          <ParamSelect
                            paramType={paramEndpoints.BANK_ACCOUNT_TYPES}
                            showSearch
                            placeholder="Seleccionar"
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={{ span: 11, offset: 1 }} xs={23}>
                        <p>
                          <span className="required">*</span>Tipo de moneda
                        </p>
                        <Form.Item
                          {...restField}
                          name={[name, 'currency']}
                          fieldKey={[fieldKey, 'currency']}
                          rules={[
                            {
                              required: true,
                              message: 'Dato requerido',
                            },
                          ]}
                        >
                          <ParamSelect
                            paramType={paramEndpoints.CURRENCIES}
                            showSearch
                            placeholder="Seleccionar"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={11} xs={23}>
                        <p>
                          <span className="required">*</span>Número de cuenta
                        </p>
                        <Form.Item
                          {...restField}
                          name={[name, 'number']}
                          fieldKey={[fieldKey, 'number']}
                          rules={[
                            {
                              required: true,
                              message: 'Dato requerido',
                            },
                          ]}
                        >
                          <InputNumber hideArrows />
                        </Form.Item>
                      </Col>
                      <Col lg={{ span: 11, offset: 1 }} xs={23}>
                        <p>
                          <span className="required">*</span>Reescriba Número de cuenta
                        </p>
                        <Form.Item
                          {...restField}
                          name={[name, 'reNnumber']}
                          dependencies={['number']}
                          fieldKey={[fieldKey, 'reNnumber']}
                          rules={[
                            {
                              required: true,
                              message: 'Dato requerido',
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  getFieldValue('dataBankito').bankAccounts[index].number === value
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('Las cuentas no coinciden'));
                              },
                            }),
                          ]}
                        >
                          <InputNumber autoComplete="off" />
                        </Form.Item>
                      </Col>
                      {fields.length > 1 && (
                        <Col span={23}>
                          <Form.Item>
                            <Button block type="dashed" onClick={() => remove(name)}>
                              - Eliminar cuenta
                            </Button>
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </>
                ))}
                <Row>
                  <Col span={23}>
                    <Form.Item>
                      <Button
                        block
                        type="dashed"
                        onClick={() =>
                          add({
                            bank: '',
                            type: '',
                            currency: '',
                            number: '',
                            reNumber: '',
                          })
                        }
                      >
                        + Agregar cuenta
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </Form.List>
          <Row>
            <Col className="formBankData__title">Datos Financieros</Col>
          </Row>
          <p>
            <span className="required">*</span>Monto estimado a operar mensual o monto potencial a
            invertir
          </p>
          <Row>
            <Col lg={11} xs={23}>
              <Form.Item
                name={['dataBankito', 'currency']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                ]}
              >
                <ParamSelect
                  paramType={paramEndpoints.CURRENCIES}
                  showSearch
                  placeholder="Seleccionar"
                />
              </Form.Item>
            </Col>
            <Col lg={{ span: 11, offset: 1 }} xs={23}>
              <Form.Item
                name={['dataBankito', 'monthlyInvestment']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                ]}
                normalize={form.normalizers.numberWithThousand}
              >
                <Input placeholder="Ingresar monto" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg={11} xs={23}>
              <p>
                <span className="required">*</span>Propósito del uso de la relación comercial
              </p>
              <Form.Item
                name={['dataBankito', 'accountPurposeId']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                ]}
              >
                <ParamSelect
                  paramType={paramEndpoints.ACCOUNT_PURPOSES}
                  showSearch
                  placeholder="Seleccionar"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg={11} xs={24}>
              <Button type="primary" className="formBankData__button" htmlType="submit">
                Continuar
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

FormBankData.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default FormBankData;
